import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div<{ isFetching?: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-row-gap: 15px;
  grid-column-gap: 10px;
  ${props => props.isFetching && `
    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: wait;
      background: rgba(255, 255, 255, 0.7);
    }
  `}

  img {
    display: block;
  }

  a {
    color: ${props => props.theme.palette.general.strong};
    text-decoration: none;
  }
`

export const NoItems = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 30px auto;
  padding: 40px 20px;
  color: ${props => props.theme.palette.general.grey};
  font: ${font('default', 'normal', '18px/1')};
  min-height: 300px;

  button {
    cursor: pointer;
    font: ${font('default', 'normal', '18px/1')};
    color: ${props => props.theme.palette.general.strong};
    margin: 0;
    padding: 7px;
    border: none;
    background: none;
  }
`
